import { render, staticRenderFns } from "./ServicesPage.vue?vue&type=template&id=dbca07e4&scoped=true"
import script from "./ServicesPage.vue?vue&type=script&lang=js"
export * from "./ServicesPage.vue?vue&type=script&lang=js"
import style0 from "./ServicesPage.vue?vue&type=style&index=0&id=dbca07e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbca07e4",
  null
  
)

export default component.exports